<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<div class="form-container configure" [ngClass]="{'loading in': loading }">
	<div class="group" [ngClass]="{'hidden': loading}">
		<div class="group-container">
			<div class="message" (click)="showCommunicationExpanded = !showCommunicationExpanded">
				<em *ngIf="!showCommunicationExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showCommunicationExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">E-mail Communication Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showCommunicationExpanded}">
				<div class="help-text">The values input below will be used on the last screen of the requesting wizard and can be modified prior to sending each request.</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="dropboxSignDefaultSubject" class="input-label">Default E-mail Subject</label>
					<div class="help-text">The subject of the e-mail that will be sent to the signers.</div>
					<input type="text" maxlength="255" id="dropboxSignDefaultSubject" [(ngModel)]="clientDetailProcore.dropboxSignDefaultSubject">
					<div *ngIf="clientDetailProcore.dropboxSignDefaultSubject" class="characters-remaining">{{ 255 - clientDetailProcore.dropboxSignDefaultSubject.length }} characters remaining</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="dropboxSignDefaultMessage" class="input-label">Default E-mail Message</label>
					<div class="help-text">The custom message in the e-mail that will be sent to the signers.</div>
					<textarea maxlength="5000" id="dropboxSignDefaultMessage" [(ngModel)]="clientDetailProcore.dropboxSignDefaultMessage" class="client-info-textarea"></textarea>
					<div *ngIf="clientDetailProcore.dropboxSignDefaultMessage" class="characters-remaining">{{ 5000 - clientDetailProcore.dropboxSignDefaultMessage.length }} characters remaining</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="dropboxSignDefaultCC" class="input-label">Default E-mail CC</label>
					<div class="help-text">A comma-separated list of e-mail addresses that will be copied on every signature request.</div>
					<input type="text" maxlength="255" id="dropboxSignDefaultCC" [(ngModel)]="clientDetailProcore.dropboxSignDefaultCC">
					<div *ngIf="clientDetailProcore.dropboxSignDefaultCC" class="characters-remaining">{{ 255 - clientDetailProcore.dropboxSignDefaultCC.length }} characters remaining</div>
				</div>
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showWorkflowExpanded = !showWorkflowExpanded">
				<em *ngIf="!showWorkflowExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showWorkflowExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Workflow Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showWorkflowExpanded}">
				<div class="help-text">Select values below to automatically update a contract to the specified status after a signature request has been sent or completed.</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="poStatusAfterRequested" class="input-label">Commitment Purchase Order</label>
					<div class="help-text">Update to status after requested:</div>
					<select id="poStatusAfterRequested" [(ngModel)]="clientDetailProcore.poStatusAfterRequested">
						<option value=""></option>
						<option value="Draft">Draft</option>
						<option value="Processing">Processing</option>
						<option value="Submitted">Submitted</option>
						<option value="Partially Received">Partially Received</option>
						<option value="Received">Received</option>
						<option value="Approved">Approved</option>
						<option value="Closed">Closed</option>
					</select>
				</div>
				<div class="field-container">
					<div class="help-text">Update to status after completed:</div>
					<select id="poStatusAfterCompleted" [(ngModel)]="clientDetailProcore.poStatusAfterCompleted">
						<option value=""></option>
						<option value="Draft">Draft</option>
						<option value="Processing">Processing</option>
						<option value="Submitted">Submitted</option>
						<option value="Partially Received">Partially Received</option>
						<option value="Received">Received</option>
						<option value="Approved">Approved</option>
						<option value="Closed">Closed</option>
					</select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="scStatusAfterRequested" class="input-label">Commitment Subcontract</label>
					<div class="help-text">Update to status after requested:</div>
					<select id="scStatusAfterRequested" [(ngModel)]="clientDetailProcore.scStatusAfterRequested">
						<option value=""></option>
						<option value="Draft">Draft</option>
						<option value="Out For Bid">Out For Bid</option>
						<option value="Out For Signature">Out For Signature</option>
						<option value="Approved">Approved</option>
						<option value="Complete">Complete</option>
						<option value="Terminated">Terminated</option>
						<option value="Void">Void</option>
					</select>
				</div>
				<div class="field-container">
					<div class="help-text">Update to status after completed:</div>
					<select id="scStatusAfterCompleted" [(ngModel)]="clientDetailProcore.scStatusAfterCompleted">
						<option value=""></option>
						<option value="Draft">Draft</option>
						<option value="Out For Bid">Out For Bid</option>
						<option value="Out For Signature">Out For Signature</option>
						<option value="Approved">Approved</option>
						<option value="Complete">Complete</option>
						<option value="Terminated">Terminated</option>
						<option value="Void">Void</option>
					</select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="ccoStatusAfterRequested" class="input-label">Commitment Change Order</label>
					<div class="help-text">Update to status after requested:</div>
					<select id="ccoStatusAfterRequested" [(ngModel)]="clientDetailProcore.ccoStatusAfterRequested">
						<option value=""></option>
						<option value="approved">Approved</option>
						<option value="draft">Draft</option>
						<option value="no_charge">No Charge</option>
						<option value="pending">Pending - In Review</option>
						<option value="not_pricing">Pending - Not Pricing</option>
						<option value="not_proceeding">Pending - Not Proceeding</option>
						<option value="pricing">Pending - Pricing</option>
						<option value="proceeding">Pending - Proceeding</option>
						<option value="revised">Pending - Revised</option>
						<option value="rejected">Rejected</option>
						<option value="void">Void</option>
					</select>
				</div>
				<div class="field-container">
					<div class="help-text">Update to status after completed:</div>
					<select id="ccoStatusAfterCompleted" [(ngModel)]="clientDetailProcore.ccoStatusAfterCompleted">
						<option value=""></option>
						<option value="approved">Approved</option>
						<option value="draft">Draft</option>
						<option value="no_charge">No Charge</option>
						<option value="pending">Pending - In Review</option>
						<option value="not_pricing">Pending - Not Pricing</option>
						<option value="not_proceeding">Pending - Not Proceeding</option>
						<option value="pricing">Pending - Pricing</option>
						<option value="proceeding">Pending - Proceeding</option>
						<option value="revised">Pending - Revised</option>
						<option value="rejected">Rejected</option>
						<option value="void">Void</option>
					</select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="ciStatusAfterRequested" class="input-label">Commitment Requisition (Invoice)</label>
					<div class="help-text">Update to status after requested:</div>
					<select id="ciStatusAfterRequested" [(ngModel)]="clientDetailProcore.ciStatusAfterRequested">
						<option value=""></option>
						<option value="draft">Draft</option>
						<option value="under_review">Under Review</option>
						<option value="revise_and_resubmit">Revise and Resubmit</option>
						<option value="approved">Approved</option>
						<option value="approved_as_noted">Approved as Noted</option>
						<option value="pending_owner_approval">Pending Owner Approval</option>
					</select>
				</div>
				<div class="field-container">
					<div class="help-text">Update to status after completed:</div>
					<select id="ciStatusAfterCompleted" [(ngModel)]="clientDetailProcore.ciStatusAfterCompleted">
						<option value=""></option>
						<option value="draft">Draft</option>
						<option value="under_review">Under Review</option>
						<option value="revise_and_resubmit">Revise and Resubmit</option>
						<option value="approved">Approved</option>
						<option value="approved_as_noted">Approved as Noted</option>
						<option value="pending_owner_approval">Pending Owner Approval</option>
					</select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="pcStatusAfterRequested" class="input-label">Prime Contract</label>
					<div class="help-text">Update to status after requested:</div>
					<select id="pcStatusAfterRequested" [(ngModel)]="clientDetailProcore.pcStatusAfterRequested">
						<option value=""></option>
						<option value="Draft">Draft</option>
						<option value="Out For Bid">Out For Bid</option>
						<option value="Out For Signature">Out For Signature</option>
						<option value="Approved">Approved</option>
						<option value="Complete">Complete</option>
						<option value="Terminated">Terminated</option>
					</select>
				</div>
				<div class="field-container">
					<div class="help-text">Update to status after completed:</div>
					<select id="pcStatusAfterCompleted" [(ngModel)]="clientDetailProcore.pcStatusAfterCompleted">
						<option value=""></option>
						<option value="Draft">Draft</option>
						<option value="Out For Bid">Out For Bid</option>
						<option value="Out For Signature">Out For Signature</option>
						<option value="Approved">Approved</option>
						<option value="Complete">Complete</option>
						<option value="Terminated">Terminated</option>
					</select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="pccoStatusAfterRequested" class="input-label">Prime Contract Change Order</label>
					<div class="help-text">Update to status after requested:</div>
					<select id="pccoStatusAfterRequested" [(ngModel)]="clientDetailProcore.pccoStatusAfterRequested">
						<option value=""></option>
						<option value="approved">Approved</option>
						<option value="draft">Draft</option>
						<option value="no_charge">No Charge</option>
						<option value="pending">Pending - In Review</option>
						<option value="not_pricing">Pending - Not Pricing</option>
						<option value="not_proceeding">Pending - Not Proceeding</option>
						<option value="pricing">Pending - Pricing</option>
						<option value="proceeding">Pending - Proceeding</option>
						<option value="revised">Pending - Revised</option>
						<option value="rejected">Rejected</option>
						<option value="void">Void</option>
					</select>
				</div>
				<div class="field-container">
					<div class="help-text">Update to status after completed:</div>
					<select id="pccoStatusAfterCompleted" [(ngModel)]="clientDetailProcore.pccoStatusAfterCompleted">
						<option value=""></option>
						<option value="approved">Approved</option>
						<option value="draft">Draft</option>
						<option value="no_charge">No Charge</option>
						<option value="pending">Pending - In Review</option>
						<option value="not_pricing">Pending - Not Pricing</option>
						<option value="not_proceeding">Pending - Not Proceeding</option>
						<option value="pricing">Pending - Pricing</option>
						<option value="proceeding">Pending - Proceeding</option>
						<option value="revised">Pending - Revised</option>
						<option value="rejected">Rejected</option>
						<option value="void">Void</option>
					</select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="pciStatusAfterRequested" class="input-label">Prime Contract Payment Application (Invoice)</label>
					<div class="help-text">Update to status after requested:</div>
					<select id="pciStatusAfterRequested" [(ngModel)]="clientDetailProcore.pciStatusAfterRequested">
						<option value=""></option>
						<option value="draft">Draft</option>
						<option value="under_review">Under Review</option>
						<option value="revise_and_resubmit">Revise and Resubmit</option>
						<option value="approved">Approved</option>
					</select>
				</div>
				<div class="field-container">
					<div class="help-text">Update to status after completed:</div>
					<select id="pciStatusAfterCompleted" [(ngModel)]="clientDetailProcore.pciStatusAfterCompleted">
						<option value=""></option>
						<option value="draft">Draft</option>
						<option value="under_review">Under Review</option>
						<option value="revise_and_resubmit">Revise and Resubmit</option>
						<option value="approved">Approved</option>
					</select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="setExcutedAfterCompleted" class="input-label">Mark as executed after signature complete:</label>
					<div class="help-text">Attempt to automatically mark a contract as executed after a signature request has been completed. This will only work if workflows are not in place.</div>
					<div class="switch block">
						<input id="setExcutedAfterCompleted" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.setExcutedAfterCompleted">
						<label for="setExcutedAfterCompleted" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="setSignedDateAfterCompleted" class="input-label">Update signed date after signature complete:</label>
					<div class="help-text">Attempt to automatically set the signed date of a contract after a signature request has been completed. This will only work if workflows are not in place.</div>
					<div class="switch block">
						<input id="setSignedDateAfterCompleted" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.setSignedDateAfterCompleted">
						<label for="setSignedDateAfterCompleted" class="switch-label">Switch</label>
					</div>
				</div>
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showFilenameExpanded = !showFilenameExpanded">
				<em *ngIf="!showFilenameExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showFilenameExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Filename Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showFilenameExpanded}">
				<div class="field-container">
					<div class="help-text">Use the fields below to construct the executed filename format for each contract type.</div>
					<div class="spacer-row">
						<div class="spacer"></div>
					</div>
					<label class="input-label">Prime Contracts</label>
					<div class="input-row">
						<select id="primeContractFilenameMarkSigned" [(ngModel)]="clientDetailProcore.primeContractFilenameMarkSigned">
							<option value="false"></option>
							<option value="true">[SIGNED]</option>
						</select>
						<select #primeContractFilename1Select id="primeContractFilename1" [(ngModel)]="clientDetailProcore.primeContractFilename1" (change)="changePrimeContractFilename1($event)">
							<option value="contractNumber">Contract #</option>
							<option value="contractOwner">Owner/Client</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
						<select id="primeContractFilename2" [(ngModel)]="clientDetailProcore.primeContractFilename2" (change)="changePrimeContractFilename2($event)">
							<option value=""></option>
							<option value="contractNumber">Contract #</option>
							<option value="contractOwner">Owner/Client</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
						<select id="primeContractFilename3" [(ngModel)]="clientDetailProcore.primeContractFilename3" (change)="changePrimeContractFilename3($event)">
							<option value=""></option>
							<option value="contractNumber">Contract #</option>
							<option value="contractOwner">Owner/Client</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
					</div>
					<div class="characters-remaining"><span *ngIf="clientDetailProcore.primeContractFilenameMarkSigned === true">[SIGNED] - </span><span>{{ primeContractFilename1Value }}</span><span *ngIf="primeContractFilename2Value"> - {{ primeContractFilename2Value }}</span><span *ngIf="primeContractFilename3Value"> - {{ primeContractFilename3Value }}</span>.pdf</div>
					<div class="spacer-row">
						<div class="spacer"></div>
					</div>
					<label class="input-label">Commitments</label>
					<div class="input-row">
						<select id="commitmentFilenameMarkSigned" [(ngModel)]="clientDetailProcore.commitmentFilenameMarkSigned">
							<option value="false"></option>
							<option value="true">[SIGNED]</option>
						</select>
						<select id="commitmentFilename1" [(ngModel)]="clientDetailProcore.commitmentFilename1" (change)="changeCommitmentFilename1($event)">
							<option value="contractNumber">Contract #</option>
							<option value="contractCompany">Contract Company</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
						<select id="commitmentFilename2" [(ngModel)]="clientDetailProcore.commitmentFilename2" (change)="changeCommitmentFilename2($event)">
							<option value=""></option>
							<option value="contractNumber">Contract #</option>
							<option value="contractCompany">Contract Company</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
						<select id="commitmentFilename3" [(ngModel)]="clientDetailProcore.commitmentFilename3" (change)="changeCommitmentFilename3($event)">
							<option value=""></option>
							<option value="contractNumber">Contract #</option>
							<option value="contractCompany">Contract Company</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
					</div>
					<div class="characters-remaining"><span *ngIf="clientDetailProcore.commitmentFilenameMarkSigned === true">[SIGNED] - </span><span>{{ commitmentFilename1Value }}</span><span *ngIf="commitmentFilename2Value"> - {{ commitmentFilename2Value }}</span><span *ngIf="commitmentFilename3Value"> - {{ commitmentFilename3Value }}</span>.pdf</div>
					<div class="spacer-row">
						<div class="spacer"></div>
					</div>
					<label class="input-label">Change Orders</label>
					<div class="input-row">
						<select id="changeOrderFilenameMarkSigned" [(ngModel)]="clientDetailProcore.changeOrderFilenameMarkSigned">
							<option value="false"></option>
							<option value="true">[SIGNED]</option>
						</select>
						<select id="changeOrderFilename1" [(ngModel)]="clientDetailProcore.changeOrderFilename1" (change)="changeChangeOrderFilename1($event)">
							<option value="contractNumber">Change Order #</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
						<select id="changeOrderFilename2" [(ngModel)]="clientDetailProcore.changeOrderFilename2" (change)="changeChangeOrderFilename2($event)">
							<option value=""></option>
							<option value="contractNumber">Change Order #</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
						<select id="changeOrderFilename3" [(ngModel)]="clientDetailProcore.changeOrderFilename3" (change)="changeChangeOrderFilename3($event)">
							<option value=""></option>
							<option value="contractNumber">Change Order #</option>
							<option value="title">Title</option>
							<option value="projectName">Project Name</option>
						</select>
					</div>
					<div class="characters-remaining"><span *ngIf="clientDetailProcore.changeOrderFilenameMarkSigned === true">[SIGNED] - </span><span>{{ changeOrderFilename1Value }}</span><span *ngIf="changeOrderFilename2Value"> - {{ changeOrderFilename2Value }}</span><span *ngIf="changeOrderFilename3Value"> - {{ changeOrderFilename3Value }}</span>.pdf</div>
				</div>
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showRequestExpanded = !showRequestExpanded">
				<em *ngIf="!showRequestExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showRequestExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Signing Request Options</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showRequestExpanded}">
				<div class="field-container switch-row" *ngIf="!clientDetailProcore.isTrial">
					<label for="dropboxSignTestMode" class="input-label">Test Mode</label>
					<div class="help-text">When in test mode, you will not be charged for signatures and requests will be sent with non-binding notices. Switch off test mode after all testing has been completed and you are ready to send real requests.</div>
					<div class="switch block">
						<input id="dropboxSignTestMode" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.dropboxSignTestMode">
						<label for="dropboxSignTestMode" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row" *ngIf="!clientDetailProcore.isTrial">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="enableMultipleAttachments" class="input-label">Enable Attachments:</label>
					<div class="help-text">When enabled, attachments can be selected to be sent for signature alongside the main contract.</div>
					<div class="switch block">
						<input id="enableMultipleAttachments" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.enableMultipleAttachments">
						<label for="enableMultipleAttachments" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="selectAllAttachments" class="input-label">Select All Attachments By Default:</label>
					<div class="help-text">When selected, attachments will be automatically selected when the side-panel is loaded.</div>
					<div class="switch block">
						<input id="selectAllAttachments" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.selectAllAttachments">
						<label for="selectAllAttachments" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="addContractSigner" class="input-label">Add Contract Signer Automatically:</label>
					<div class="help-text">When enabled, the Contract Signer will be added to the request as a signer automatically. The Contract Signer will not be added if using templates or modifying a previous request.</div>
					<div class="switch block">
						<input id="addContractSigner" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.addContractSigner">
						<label for="addContractSigner" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="addContractSigner" class="input-label">Contract Signer Role:</label>
					<div class="help-text">This role is used to place the contract signer in the correct location, and should match the role from the Dropbox Sign template. If no matching role is found, it will place the contract signer in the first signer location.</div>
					<input type="text" maxlength="50" id="addContractSignerRole" [(ngModel)]="clientDetailProcore.addContractSignerRole">
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="enableDropboxSignTemplates" class="input-label">Enable Dropbox Sign Templates:</label>
					<div class="help-text">When enabled, this option allows you to select a template from Dropbox Sign to replace the main Procore contract.</div>
					<div class="switch block">
						<input id="enableDropboxSignTemplates" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.enableDropboxSignTemplates">
						<label for="enableDropboxSignTemplates" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="allowDeclineRequest" class="input-label">Allow selecting if the signer can Decline a request:</label>
					<div class="help-text">When enabled, requestors can choose to allow the signer to decline the signature request.</div>
					<div class="switch block">
						<input id="allowDeclineRequest" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.allowDeclineRequest">
						<label for="allowDeclineRequest" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="declineRequestDefault" class="input-label">Default value for Decline a request:</label>
					<div class="help-text">This sets the default value for allowing a signer to decline a signature request.</div>
					<div class="switch block">
						<input id="declineRequestDefault" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.declineRequestDefault">
						<label for="declineRequestDefault" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="allowSignerReassignment" class="input-label">Allow Signer Re-Assignment:</label>
					<div class="help-text">Allow selecting if a signer can re-assign a request (premium plans only).</div>
					<div class="switch block">
						<input id="allowSignerReassignment" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.allowSignerReassignment">
						<label for="allowSignerReassignment" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="allowExpirationDate" class="input-label">Allow setting an expiration date:</label>
					<div class="help-text">Allow setting an enforced expiration date for the signature request.</div>
					<div class="switch block">
						<input id="allowExpirationDate" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.allowExpirationDate">
						<label for="allowExpirationDate" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label for="requestorEmailType" class="input-label">Requestor:</label>
					<div class="help-text">The user that signature requests will be e-mailed from.</div>
					<select id="requestorEmailType" [(ngModel)]="clientDetailProcore.requestorEmailType">
						<option value="default">{{ clientDetailProcore.dropboxSignAccountType === 'OAUTH' ? 'Current User\'s E-mail Address' : 'Dropbox Sign App User\'s E-mail Address' }}</option>
						<option value="custom">Custom E-mail Address</option>
					</select>
				</div>
				<div class="spacer-row" *ngIf="clientDetailProcore.requestorEmailType === 'custom'">
					<div class="spacer"></div>
				</div>
				<div class="field-container" *ngIf="clientDetailProcore.requestorEmailType === 'custom'">
					<label for="customRequestorEmail" class="input-label">Request E-mail Address:</label>
					<input type="text" id="customRequestorEmail" [(ngModel)]="clientDetailProcore.customRequestorEmail">
				</div>
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showRequestTemplatesExpanded = !showRequestTemplatesExpanded">
				<em *ngIf="!showRequestTemplatesExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showRequestTemplatesExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Request Template Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showRequestTemplatesExpanded}">
				<div class="field-container switch-row">
					<label for="enableDropboxSignTemplateOverlays" class="input-label">Enable Dropbox Sign Request Templates:</label>
					<div class="help-text">When enabled, this option allows you to select a template from Dropbox Sign to overlay the signers and signing locations on the main contract.</div>
					<div class="switch block">
						<input id="enableDropboxSignTemplateOverlays" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.enableDropboxSignTemplateOverlays" (change)="changeEnableDropboxSignTemplateOverlays($event)">
						<label for="enableDropboxSignTemplateOverlays" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="enableDropboxSignTemplateOverlayFields" class="input-label">Place Signing Locations:</label>
					<div class="help-text">When enabled, the signing locations from the template will be added to the main contract.</div>
					<div class="switch block">
						<input id="enableDropboxSignTemplateOverlayFields" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.enableDropboxSignTemplateOverlayFields">
						<label for="enableDropboxSignTemplateOverlayFields" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<!-- <div class="field-container switch-row">
					<label for="enableDropboxSignTemplateOverlayCCs" class="input-label">Include CCs:</label>
					<div class="help-text">When enabled, CCs will be pulled from the Request Template and override any default values.</div>
					<div class="switch block">
						<input id="enableDropboxSignTemplateOverlayCCs" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.enableDropboxSignTemplateOverlayCCs">
						<label for="enableDropboxSignTemplateOverlayCCs" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="enableDropboxSignTemplateOverlayMessage" class="input-label">Include E-mail Message:</label>
					<div class="help-text">When enabled, the e-mail message will be pulled from the Request Template and override any default values.</div>
					<div class="switch block">
						<input id="enableDropboxSignTemplateOverlayMessage" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.enableDropboxSignTemplateOverlayMessage">
						<label for="enableDropboxSignTemplateOverlayMessage" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div> -->
				<div class="help-text">Select values below to automatically load a request template for the corresponding contract type.</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="" class="input-label">Commitment Purchase Order</label>
					<!-- <div class="help-text">Load template:</div> -->
					<ng-select placeholder="Select a template" [addTag]="false" [items]="templates" id="templateCPO" bindLabel="title" bindValue="template_id" [clearable]="true" [(ngModel)]="clientDetailProcore.defaultRequestTemplateCommitmentPurchaseOrder" (clear)="clearDefaultRequestTemplateCommitmentPurchaseOrder()"></ng-select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="" class="input-label">Commitment Purchase Order Change Order</label>
					<!-- <div class="help-text">Load template:</div> -->
					<ng-select placeholder="Select a template" [addTag]="false" [items]="templates" id="templateCPOCO" bindLabel="title" bindValue="template_id" [clearable]="true" [(ngModel)]="clientDetailProcore.defaultRequestTemplateCommitmentPurchaseOrderChangeOrder" (clear)="clearDefaultRequestTemplateCommitmentPurchaseOrderChangeOrder()"></ng-select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="" class="input-label">Commitment Subcontract</label>
					<!-- <div class="help-text">Load template:</div> -->
					<ng-select placeholder="Select a template" [addTag]="false" [items]="templates" id="templateCSC" bindLabel="title" bindValue="template_id" [clearable]="true" [(ngModel)]="clientDetailProcore.defaultRequestTemplateCommitmentSubcontract" (clear)="clearDefaultRequestTemplateCommitmentSubcontract()"></ng-select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="" class="input-label">Commitment Subcontract Change Order</label>
					<!-- <div class="help-text">Load template:</div> -->
					<ng-select placeholder="Select a template" [addTag]="false" [items]="templates" id="templateCSCCO" bindLabel="title" bindValue="template_id" [clearable]="true" [(ngModel)]="clientDetailProcore.defaultRequestTemplateCommitmentSubcontractChangeOrder" (clear)="clearDefaultRequestTemplateCommitmentSubcontractChangeOrder()"></ng-select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="" class="input-label">Prime Contract</label>
					<!-- <div class="help-text">Load template:</div> -->
					<ng-select placeholder="Select a template" [addTag]="false" [items]="templates" id="templatePC" bindLabel="title" bindValue="template_id" [clearable]="true" [(ngModel)]="clientDetailProcore.defaultRequestTemplatePrimeContract" (clear)="clearDefaultRequestTemplatePrimeContract()"></ng-select>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="" class="input-label">Prime Contract Change Order</label>
					<!-- <div class="help-text">Load template:</div> -->
					<ng-select placeholder="Select a template" [addTag]="false" [items]="templates" id="templatePCCO" bindLabel="title" bindValue="template_id" [clearable]="true" [(ngModel)]="clientDetailProcore.defaultRequestTemplatePrimeContractChangeOrder" (clear)="clearDefaultRequestTemplatePrimeContractChangeOrder()"></ng-select>
				</div>

				<!-- Commitment Potential Change Order ? -->
				<!-- Prime Contract Potential Change Order ? -->
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showStorageExpanded = !showStorageExpanded">
				<em *ngIf="!showStorageExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showStorageExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Storage Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showStorageExpanded}">
				<div class="field-container switch-row">
					<label for="allowDefaultLocationOverride" class="input-label">Allow Overriding Default Locations:</label>
					<div class="help-text">When enabled, users can override the file storage location when sending a request.</div>
					<div class="switch block">
						<input id="allowDefaultLocationOverride" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="projectConfigs.allowDefaultLocationOverride">
						<label for="allowDefaultLocationOverride" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="attachChangeOrderToParent" class="input-label">Attach Change Order to Parent:</label>
					<div class="help-text">When enabled, the executed file will be attached to the parent of the change order instead of the change order itself.</div>
					<div class="switch block">
						<input id="attachChangeOrderToParent" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.attachChangeOrderToParent">
						<label for="attachChangeOrderToParent" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="field-container switch-row">
					<label for="attachInvoiceToParent" class="input-label">Attach Invoice to Parent:</label>
					<div class="help-text">When enabled, the executed file will be attached to the parent of the invoice instead of the invoice itself.</div>
					<div class="switch block">
						<input id="attachInvoiceToParent" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.attachInvoiceToParent">
						<label for="attachInvoiceToParent" class="switch-label">Switch</label>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container">
					<label class="input-label">Default File Storage Locations:</label>
					<div class="help-text">Specifies where the signed document should be stored after all parties have signed. These are project-specific and must be set for every project.</div>
					<br />
					<label for="primeContractStorage" class="input-label">Prime Contracts:</label>
					<select id="primeContractStorage" [(ngModel)]="projectConfigs.primeContractStorage">
						<option value="default">Prime Contract</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
					<label for="primeContractCoStorage" class="input-label">Prime Contract Change Orders:</label>
					<select id="primeContractCoStorage" [(ngModel)]="projectConfigs.primeContractCoStorage">
						<option value="default">Prime Contract</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
					<label for="primeContractPcoStorage" class="input-label">Prime Contract Potential Change Orders:</label>
					<select id="primeContractPcoStorage" [(ngModel)]="projectConfigs.primeContractPcoStorage">
						<option value="default">Prime Contract</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
					<label for="subcontractStorage" class="input-label">Subcontracts:</label>
					<select id="subcontractStorage" [(ngModel)]="projectConfigs.subcontractStorage">
						<option value="default">Subcontract</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
					<label for="subcontractCoStorage" class="input-label">Subcontract Change Orders:</label>
					<select id="subcontractCoStorage" [(ngModel)]="projectConfigs.subcontractCoStorage">
						<option value="default">Subcontract</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
					<label for="subcontractPcoStorage" class="input-label">Subcontract Potential Change Orders:</label>
					<select id="subcontractPcoStorage" [(ngModel)]="projectConfigs.subcontractPcoStorage">
						<option value="default">Subcontract</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
					<label for="purchaseOrderStorage" class="input-label">Purchase Orders:</label>
					<select id="purchaseOrderStorage" [(ngModel)]="projectConfigs.purchaseOrderStorage">
						<option value="default">Purchase Order</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
					<label for="purchaseOrderCoStorage" class="input-label">Purchase Order Change Order:</label>
					<select id="purchaseOrderCoStorage" [(ngModel)]="projectConfigs.purchaseOrderCoStorage">
						<option value="default">Purchase Order</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
					<label for="purchaseOrderPcoStorage" class="input-label">Purchase Order Potential Change Order:</label>
					<select id="purchaseOrderPcoStorage" [(ngModel)]="projectConfigs.purchaseOrderPcoStorage">
						<option value="default">Purchase Order</option>
						<option *ngFor="let folderOption of folderOptions" [value]="folderOption.id">{{ folderOption.name }}</option>
					</select>
				</div>
			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="showSecurityExpanded = !showSecurityExpanded">
				<em *ngIf="!showSecurityExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showSecurityExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Security Settings</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showSecurityExpanded}">
				<div class="apikey-message" *ngIf="!contextService.signatureCount.dropboxSignApiKeyExists && contextService.clientDetailProcore.dropboxSignAccountType == 'OAUTH'">
					To enable these features, a Dropbox Sign API Key must be configured. Please contact Shake IT for more information.
				</div>
				<div class="apikey-message" *ngIf="contextService.clientDetailProcore.dropboxSignAccountType !== 'OAUTH'">
					These features are automatically enabled since all Procore users share a single Dropbox Sign account. Please contact Shake IT for more information.
				</div>
				<div class="field-container switch-row">
					<label for="anyUserCanCancel" class="input-label">Allow any user to cancel a request:</label>
					<div class="help-text">By default, only admins and the user who sent the request can cancel a document. Enable this to allow any user to cancel any request.</div>
					<div class="switch block" *ngIf="contextService.signatureCount.dropboxSignApiKeyExists && contextService.clientDetailProcore.dropboxSignAccountType == 'OAUTH'">
						<input id="anyUserCanCancel" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.anyUserCanCancel">
						<label for="anyUserCanCancel" class="switch-label">Switch</label>
					</div>
					<div class="switch block" *ngIf="!contextService.signatureCount.dropboxSignApiKeyExists">
						<i class="fas fa-times"></i>
					</div>
					<div class="switch block" *ngIf="contextService.clientDetailProcore.dropboxSignAccountType !== 'OAUTH'">
						<i class="fas fa-check"></i>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="anyUserCanSendReminder" class="input-label">Allow any user to send a reminder:</label>
					<div class="help-text">By default, only admins and the user who sent the request can send a reminder. Enable this to allow any user to send a reminder for any request.</div>
					<div class="switch block" *ngIf="contextService.signatureCount.dropboxSignApiKeyExists && contextService.clientDetailProcore.dropboxSignAccountType == 'OAUTH'">
						<input id="anyUserCanSendReminder" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.anyUserCanSendReminder">
						<label for="anyUserCanSendReminder" class="switch-label">Switch</label>
					</div>
					<div class="switch block" *ngIf="!contextService.signatureCount.dropboxSignApiKeyExists">
						<i class="fas fa-times"></i>
					</div>
					<div class="switch block" *ngIf="contextService.clientDetailProcore.dropboxSignAccountType !== 'OAUTH'">
						<i class="fas fa-check"></i>
					</div>
				</div>
				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="anyUserCanDownload" class="input-label">Allow any user to download the executed document:</label>
					<div class="help-text">By default, only admins and the user who sent the request can download the executed document. Enable this to allow any user to download any executed document.</div>
					<div class="switch block" *ngIf="contextService.signatureCount.dropboxSignApiKeyExists && contextService.clientDetailProcore.dropboxSignAccountType == 'OAUTH'">
						<input id="anyUserCanDownload" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.anyUserCanDownload">
						<label for="anyUserCanDownload" class="switch-label">Switch</label>
					</div>
					<div class="switch block" *ngIf="!contextService.signatureCount.dropboxSignApiKeyExists">
						<i class="fas fa-times"></i>
					</div>
					<div class="switch block" *ngIf="contextService.clientDetailProcore.dropboxSignAccountType !== 'OAUTH'">
						<i class="fas fa-check"></i>
					</div>
				</div>

				<div class="spacer-row">
					<div class="spacer"></div>
				</div>
				<div class="field-container switch-row">
					<label for="nonUsersCanViewStatus" class="input-label">Allow non-users to view the request status:</label>
					<div class="help-text">Allow users without a Dropbox Sign account to view the status of a request within the side-panel.</div>
					<div class="switch block" *ngIf="contextService.signatureCount.dropboxSignApiKeyExists">
						<input id="nonUsersCanViewStatus" type="checkbox" class="switch-input client-checkbox" [(ngModel)]="clientDetailProcore.nonUsersCanViewStatus">
						<label for="nonUsersCanViewStatus" class="switch-label">Switch</label>
					</div>
					<div class="switch block" *ngIf="!contextService.signatureCount.dropboxSignApiKeyExists">
						<i class="fas fa-times"></i>
					</div>
				</div>

			</div>
		</div>

		<div class="group-container">
			<div class="message" (click)="expandUsers()">
				<em *ngIf="!showUsersExpanded" class="fas fa-angle-down expand"></em>
				<em *ngIf="showUsersExpanded" class="fas fa-angle-up expand"></em>
				<div class="group-title">Users</div>
			</div>
			<div class="data" [ngClass]="{'hidden': !showUsersExpanded}">
				<div class="loading-container" *ngIf="loadingUsers">
					<div class="lds-facebook">
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
				<div class="no-exist-message" *ngIf="!loadingUsers && users.length == 0">No users exist.</div>
				<div *ngFor="let user of users" class="user-row">
					{{ user.userName }}
					<i *ngIf="!userToDelete && user.userName !== contextService.procoreUserInfo.email" class="fas fa-times" (click)="deleteUser(user)"></i>
					<i *ngIf="userToDelete == user" class="fas fa-solid fa-circle-notch fa-spin"></i>
				</div>
			</div>
		</div>
		<div class="button-container">
			<button type="button" class="btn" (click)="updateConfigurations()">Save</button>
			<button type="button" class="btn secondary" (click)="cancelConfigurations()">Cancel</button>
		</div>
	</div>
</div>